import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getCdrEntryBindingRichTextOptions } from '@/utils/contentfulRichTextBindings';

const richTextOptions = getCdrEntryBindingRichTextOptions({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_node, children) => <>{children}</>
  }
});

const renderRichText = richText =>
  richText?.nodeType === 'document'
    ? documentToReactComponents(richText, richTextOptions)
    : undefined;

export const getOfferSelectorDataFromContentful = data => {
  if (!data?.offers?.length) return null;

  return {
    heading: data.heading,
    pillText: data.pillText,
    tcText: data.tcText,
    offers: data.offers.map(offer => ({
      id: offer.optionId || offer.id,
      title: offer.title,
      subtitle: offer.subtitle,
      content: renderRichText(offer.content) || offer.content,
      productId: offer.productId,
      ctaText: offer.ctaText,
      ctaURL: offer.ctaURL
    }))
  };
};
